"use client";
import React from "react";

interface inputInterface {
  name: string;
  label: string;
  value: any;
  placeholder?: any;
  setValue: any;
  error: string;
  disabled: boolean;
}
const Input = ({
  disabled = false,
  name,
  label,
  value,
  placeholder,
  setValue,
  error,
}: inputInterface) => {
  return (
    <div className="flex flex-col relative">
      <label htmlFor={name} className="text-md mb-2">
        {label}
      </label>
      <input
        className="outline-none bg-neutral-100 text-neutral-900 py-2 px-4 rounded-full disabled:text-gray-400 transition-colors text-sm"
        type="text"
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        onChange={(e) => setValue(e.target.value)}
      />
      {error && (
        <small className="text-red-500 absolute -bottom-6 left-0 text-[13px]">
          {error}
        </small>
      )}
    </div>
  );
};

export default Input;
